'use strict';

var cov_p79854qay = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/NucleoManager/lib/index.js',
      hash = '4aa987a8da5b3202a0abd909b4c930126190ecb4',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/NucleoManager/lib/index.js',
    statementMap: {
      '0': {
        start: {
          line: 6,
          column: 26
        },
        end: {
          line: 40,
          column: 1
        }
      },
      '1': {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 10,
          column: 3
        }
      },
      '2': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      '3': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 69
        }
      },
      '4': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 52
        }
      },
      '5': {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '6': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 36,
          column: 7
        }
      },
      '7': {
        start: {
          line: 19,
          column: 29
        },
        end: {
          line: 25,
          column: 9
        }
      },
      '8': {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 28,
          column: 11
        }
      },
      '9': {
        start: {
          line: 27,
          column: 10
        },
        end: {
          line: 27,
          column: 81
        }
      },
      '10': {
        start: {
          line: 29,
          column: 13
        },
        end: {
          line: 36,
          column: 7
        }
      },
      '11': {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 53
        }
      },
      '12': {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 53
        }
      },
      '13': {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 61
        }
      },
      '14': {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 83
        }
      },
      '15': {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 19
        }
      },
      '16': {
        start: {
          line: 74,
          column: 25
        },
        end: {
          line: 119,
          column: 1
        }
      },
      '17': {
        start: {
          line: 75,
          column: 18
        },
        end: {
          line: 75,
          column: 20
        }
      },
      '18': {
        start: {
          line: 76,
          column: 18
        },
        end: {
          line: 76,
          column: 20
        }
      },
      '19': {
        start: {
          line: 77,
          column: 21
        },
        end: {
          line: 77,
          column: 58
        }
      },
      '20': {
        start: {
          line: 78,
          column: 20
        },
        end: {
          line: 78,
          column: 67
        }
      },
      '21': {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 113,
          column: 5
        }
      },
      '22': {
        start: {
          line: 80,
          column: 22
        },
        end: {
          line: 80,
          column: 37
        }
      },
      '23': {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 112,
          column: 5
        }
      },
      '24': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 62
        }
      },
      '25': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 40
        }
      },
      '26': {
        start: {
          line: 84,
          column: 25
        },
        end: {
          line: 84,
          column: 27
        }
      },
      '27': {
        start: {
          line: 85,
          column: 25
        },
        end: {
          line: 85,
          column: 27
        }
      },
      '28': {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 94,
          column: 9
        }
      },
      '29': {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 93,
          column: 9
        }
      },
      '30': {
        start: {
          line: 88,
          column: 10
        },
        end: {
          line: 88,
          column: 73
        }
      },
      '31': {
        start: {
          line: 89,
          column: 10
        },
        end: {
          line: 89,
          column: 73
        }
      },
      '32': {
        start: {
          line: 91,
          column: 10
        },
        end: {
          line: 91,
          column: 57
        }
      },
      '33': {
        start: {
          line: 92,
          column: 10
        },
        end: {
          line: 92,
          column: 57
        }
      },
      '34': {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 98,
          column: 7
        }
      },
      '35': {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 34
        }
      },
      '36': {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 97,
          column: 34
        }
      },
      '37': {
        start: {
          line: 100,
          column: 25
        },
        end: {
          line: 100,
          column: 55
        }
      },
      '38': {
        start: {
          line: 103,
          column: 25
        },
        end: {
          line: 103,
          column: 27
        }
      },
      '39': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 106,
          column: 9
        }
      },
      '40': {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 55
        }
      },
      '41': {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 109,
          column: 7
        }
      },
      '42': {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 108,
          column: 50
        }
      },
      '43': {
        start: {
          line: 108,
          column: 44
        },
        end: {
          line: 108,
          column: 49
        }
      },
      '44': {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 64
        }
      },
      '45': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 71
        }
      },
      '46': {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 118,
          column: 4
        }
      },
      '47': {
        start: {
          line: 121,
          column: 22
        },
        end: {
          line: 131,
          column: 1
        }
      },
      '48': {
        start: {
          line: 122,
          column: 21
        },
        end: {
          line: 122,
          column: 23
        }
      },
      '49': {
        start: {
          line: 123,
          column: 2
        },
        end: {
          line: 129,
          column: 5
        }
      },
      '50': {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      '51': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 37
        }
      },
      '52': {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 127,
          column: 52
        }
      },
      '53': {
        start: {
          line: 130,
          column: 2
        },
        end: {
          line: 130,
          column: 37
        }
      },
      '54': {
        start: {
          line: 133,
          column: 33
        },
        end: {
          line: 141,
          column: 1
        }
      },
      '55': {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 139,
          column: 3
        }
      },
      '56': {
        start: {
          line: 140,
          column: 2
        },
        end: {
          line: 140,
          column: 15
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 6,
            column: 26
          },
          end: {
            line: 6,
            column: 27
          }
        },
        loc: {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 6
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 17,
            column: 40
          },
          end: {
            line: 17,
            column: 41
          }
        },
        loc: {
          start: {
            line: 17,
            column: 47
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 17
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 26,
            column: 42
          },
          end: {
            line: 26,
            column: 43
          }
        },
        loc: {
          start: {
            line: 26,
            column: 55
          },
          end: {
            line: 28,
            column: 9
          }
        },
        line: 26
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 74,
            column: 25
          },
          end: {
            line: 74,
            column: 26
          }
        },
        loc: {
          start: {
            line: 74,
            column: 58
          },
          end: {
            line: 119,
            column: 1
          }
        },
        line: 74
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 79,
            column: 34
          },
          end: {
            line: 79,
            column: 35
          }
        },
        loc: {
          start: {
            line: 79,
            column: 41
          },
          end: {
            line: 113,
            column: 3
          }
        },
        line: 79
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 86,
            column: 45
          },
          end: {
            line: 86,
            column: 46
          }
        },
        loc: {
          start: {
            line: 86,
            column: 55
          },
          end: {
            line: 94,
            column: 7
          }
        },
        line: 86
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 104,
            column: 25
          },
          end: {
            line: 104,
            column: 26
          }
        },
        loc: {
          start: {
            line: 104,
            column: 35
          },
          end: {
            line: 106,
            column: 7
          }
        },
        line: 104
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 108,
            column: 35
          },
          end: {
            line: 108,
            column: 36
          }
        },
        loc: {
          start: {
            line: 108,
            column: 44
          },
          end: {
            line: 108,
            column: 49
          }
        },
        line: 108
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 121,
            column: 22
          },
          end: {
            line: 121,
            column: 23
          }
        },
        loc: {
          start: {
            line: 121,
            column: 33
          },
          end: {
            line: 131,
            column: 1
          }
        },
        line: 121
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 123,
            column: 31
          },
          end: {
            line: 123,
            column: 32
          }
        },
        loc: {
          start: {
            line: 123,
            column: 38
          },
          end: {
            line: 129,
            column: 3
          }
        },
        line: 123
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 133,
            column: 33
          },
          end: {
            line: 133,
            column: 34
          }
        },
        loc: {
          start: {
            line: 133,
            column: 43
          },
          end: {
            line: 141,
            column: 1
          }
        },
        line: 133
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }],
        line: 12
      },
      '1': {
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }, {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }],
        line: 18
      },
      '2': {
        loc: {
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 27,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 27,
            column: 53
          }
        }, {
          start: {
            line: 27,
            column: 57
          },
          end: {
            line: 27,
            column: 80
          }
        }],
        line: 27
      },
      '3': {
        loc: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 36,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 36,
            column: 7
          }
        }, {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 36,
            column: 7
          }
        }],
        line: 29
      },
      '4': {
        loc: {
          start: {
            line: 78,
            column: 20
          },
          end: {
            line: 78,
            column: 67
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 78,
            column: 36
          },
          end: {
            line: 78,
            column: 62
          }
        }, {
          start: {
            line: 78,
            column: 65
          },
          end: {
            line: 78,
            column: 67
          }
        }],
        line: 78
      },
      '5': {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }],
        line: 81
      },
      '6': {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 93,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 93,
            column: 9
          }
        }, {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 93,
            column: 9
          }
        }],
        line: 87
      },
      '7': {
        loc: {
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 88,
            column: 72
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 88,
            column: 43
          }
        }, {
          start: {
            line: 88,
            column: 47
          },
          end: {
            line: 88,
            column: 72
          }
        }],
        line: 88
      },
      '8': {
        loc: {
          start: {
            line: 89,
            column: 28
          },
          end: {
            line: 89,
            column: 72
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 89,
            column: 28
          },
          end: {
            line: 89,
            column: 43
          }
        }, {
          start: {
            line: 89,
            column: 47
          },
          end: {
            line: 89,
            column: 72
          }
        }],
        line: 89
      },
      '9': {
        loc: {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        }, {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 98,
            column: 7
          }
        }],
        line: 95
      },
      '10': {
        loc: {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        }, {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        }],
        line: 107
      },
      '11': {
        loc: {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }, {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }],
        line: 124
      },
      '12': {
        loc: {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 39
          }
        }, {
          start: {
            line: 137,
            column: 43
          },
          end: {
            line: 137,
            column: 80
          }
        }],
        line: 137
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNucleoStore = exports.getNucleo = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _Localizer = require('./Localizer');

var Localizer = _interopRequireWildcard(_Localizer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cov_p79854qay.s[0]++;


var localizeSubNucleo = function localizeSubNucleo(nucleo, name) {
  cov_p79854qay.f[0]++;

  var subGlobal = (cov_p79854qay.s[1]++, {
    actions: {},
    reducer: {}
  });
  // by side effect modify the function for the reducer and the actions
  cov_p79854qay.s[2]++;
  if (nucleo.reducer instanceof Function) {
    cov_p79854qay.b[0][0]++;
    cov_p79854qay.s[3]++;

    // eslint-disable-next-line no-param-reassign
    nucleo.reducer = Localizer.localizeReducer(nucleo.reducer, name);
    cov_p79854qay.s[4]++;
    Localizer.localizeActions(nucleo.actions, name);
  } else {
    cov_p79854qay.b[0][1]++;
    cov_p79854qay.s[5]++;

    (0, _keys2.default)(nucleo.reducer).forEach(function (key) {
      cov_p79854qay.f[1]++;
      cov_p79854qay.s[6]++;

      if (!(nucleo.reducer[key] instanceof Function)) {
        cov_p79854qay.b[1][0]++;

        var curSubGlobal = (cov_p79854qay.s[7]++, localizeSubNucleo({
          actions: nucleo.actions[key],
          reducer: nucleo.reducer[key]
        }, name));
        cov_p79854qay.s[8]++;
        (0, _keys2.default)(curSubGlobal).forEach(function (globalKey) {
          cov_p79854qay.f[2]++;
          cov_p79854qay.s[9]++;

          subGlobal[globalKey] = (cov_p79854qay.b[2][0]++, subGlobal[globalKey]) || (cov_p79854qay.b[2][1]++, curSubGlobal[globalKey]);
        });
      } else {
          cov_p79854qay.b[1][1]++;
          cov_p79854qay.s[10]++;
          if (nucleo.globalNames.includes(key)) {
            cov_p79854qay.b[3][0]++;
            cov_p79854qay.s[11]++;

            subGlobal.actions[key] = nucleo.actions[key];
            cov_p79854qay.s[12]++;
            subGlobal.reducer[key] = nucleo.reducer[key];
          } else {
            cov_p79854qay.b[3][1]++;
            cov_p79854qay.s[13]++;

            Localizer.localizeActions(nucleo.actions[key], name);
            // eslint-disable-next-line no-param-reassign
            cov_p79854qay.s[14]++;
            nucleo.reducer[key] = Localizer.localizeReducer(nucleo.reducer[key], name);
          }
        }
    });
  }
  cov_p79854qay.s[15]++;
  return subGlobal;
};

/*
 * Convenient function that generate the private reducer and actions adapted to the path
 *actionDef = {
 *  objectName: {
 *   actions : {
 *      action1 : fn,
 *      action2 : fn,
 *      action3 : fn,
 *    },
 *    reducer : fn,
 *  },
  or
 *  objectName2: {
 *   actions : {
 *      subObjectName1 : {},
 *      subObjectName2 : {},
 *      subObjectName3 : {},
 *    },
 *    reducer : {
 *      subObjectName1: fn,
 *      subObjectName2: fn,
 *      subObjectName3: fn,
 *    },
 *    global: [
 *      globalObjectName1,
 *      globalObjectName2,
 *      ...],
 *    localize: fn,
 *  },
 * ...
 *}
 */
cov_p79854qay.s[16]++;
var getNucleo = exports.getNucleo = function getNucleo(localNucleos, globalNucleos) {
  cov_p79854qay.f[3]++;

  var actions = (cov_p79854qay.s[17]++, {});
  var reducer = (cov_p79854qay.s[18]++, {});
  var allNucleos = (cov_p79854qay.s[19]++, (0, _extends3.default)({}, localNucleos, globalNucleos));
  var globalNames = (cov_p79854qay.s[20]++, globalNucleos ? (cov_p79854qay.b[4][0]++, (0, _keys2.default)(globalNucleos)) : (cov_p79854qay.b[4][1]++, []));
  cov_p79854qay.s[21]++;
  (0, _keys2.default)(allNucleos).forEach(function (key) {
    cov_p79854qay.f[4]++;

    var curNucleo = (cov_p79854qay.s[22]++, allNucleos[key]);
    cov_p79854qay.s[23]++;
    if (curNucleo.globalNames instanceof Array) {
      cov_p79854qay.b[5][0]++;
      cov_p79854qay.s[24]++;

      globalNames = globalNames.concat(curNucleo.globalNames);
      cov_p79854qay.s[25]++;
      localizeSubNucleo(curNucleo, key);
      var curActions = (cov_p79854qay.s[26]++, {});
      var curReducer = (cov_p79854qay.s[27]++, {});
      cov_p79854qay.s[28]++;
      (0, _keys2.default)(curNucleo.reducer).forEach(function (curKey) {
        cov_p79854qay.f[5]++;
        cov_p79854qay.s[29]++;

        if (globalNames.includes(curKey)) {
          cov_p79854qay.b[6][0]++;
          cov_p79854qay.s[30]++;

          actions[curKey] = (cov_p79854qay.b[7][0]++, actions[curKey]) || (cov_p79854qay.b[7][1]++, curNucleo.actions[curKey]);
          cov_p79854qay.s[31]++;
          reducer[curKey] = (cov_p79854qay.b[8][0]++, reducer[curKey]) || (cov_p79854qay.b[8][1]++, curNucleo.reducer[curKey]);
        } else {
          cov_p79854qay.b[6][1]++;
          cov_p79854qay.s[32]++;

          curActions[curKey] = curNucleo.actions[curKey];
          cov_p79854qay.s[33]++;
          curReducer[curKey] = curNucleo.reducer[curKey];
        }
      });
      cov_p79854qay.s[34]++;
      if ((0, _keys2.default)(curActions).length > 0) {
        cov_p79854qay.b[9][0]++;
        cov_p79854qay.s[35]++;

        actions[key] = curActions;
        cov_p79854qay.s[36]++;
        reducer[key] = curReducer;
      } else {
        cov_p79854qay.b[9][1]++;
      }
    } else {
      cov_p79854qay.b[5][1]++;

      var actionKeys = (cov_p79854qay.s[37]++, (0, _keys2.default)(curNucleo.actions));

      // ensure no side effect on same actions
      var newActions = (cov_p79854qay.s[38]++, {});
      cov_p79854qay.s[39]++;
      actionKeys.forEach(function (fnName) {
        cov_p79854qay.f[6]++;
        cov_p79854qay.s[40]++;

        newActions[fnName] = curNucleo.actions[fnName];
      });
      cov_p79854qay.s[41]++;
      if (!newActions.getLocalState) {
        cov_p79854qay.b[10][0]++;
        cov_p79854qay.s[42]++;

        newActions.getLocalState = function (state) {
          cov_p79854qay.f[7]++;
          cov_p79854qay.s[43]++;
          return state;
        };
      } else {
        cov_p79854qay.b[10][1]++;
      }
      cov_p79854qay.s[44]++;
      actions[key] = Localizer.localizeActions(newActions, key);
      cov_p79854qay.s[45]++;
      reducer[key] = Localizer.localizeReducer(curNucleo.reducer, key);
    }
  });
  cov_p79854qay.s[46]++;
  return {
    actions: actions,
    reducer: reducer,
    globalNames: globalNames
  };
};

cov_p79854qay.s[47]++;
var getSubReducer = function getSubReducer(reducer) {
  cov_p79854qay.f[8]++;

  var curReducer = (cov_p79854qay.s[48]++, {});
  cov_p79854qay.s[49]++;
  (0, _keys2.default)(reducer).forEach(function (key) {
    cov_p79854qay.f[9]++;
    cov_p79854qay.s[50]++;

    if (reducer[key] instanceof Function) {
      cov_p79854qay.b[11][0]++;
      cov_p79854qay.s[51]++;

      curReducer[key] = reducer[key];
    } else {
      cov_p79854qay.b[11][1]++;
      cov_p79854qay.s[52]++;

      curReducer[key] = getSubReducer(reducer[key]);
    }
  });
  cov_p79854qay.s[53]++;
  return (0, _redux.combineReducers)(curReducer);
};

cov_p79854qay.s[54]++;
var createNucleoStore = exports.createNucleoStore = function createNucleoStore(nucleo) {
  cov_p79854qay.f[10]++;

  var store = (cov_p79854qay.s[55]++, (0, _redux.createStore)(getSubReducer(nucleo.reducer),
  // eslint-disable-next-line no-underscore-dangle
  (cov_p79854qay.b[12][0]++, window.__REDUX_DEVTOOLS_EXTENSION__) && (cov_p79854qay.b[12][1]++, window.__REDUX_DEVTOOLS_EXTENSION__()), (0, _redux.applyMiddleware)(_reduxThunk2.default)));
  cov_p79854qay.s[56]++;
  return store;
};

exports.default = getNucleo;